import React from "react";
import { withPrefix } from "gatsby";

import Button from "../button/button";
import { getFormatDate } from "../../../shared/utils/dateUtilities";
import { normalizeTwoWords, formatImageAlt, findRel } from "../../../shared/utils/stringUtilities";
import DefaultImage from "../../../assets/images/not-found/icono_horizontal_articulos.jpg";

import "./cardArticle.scss";

interface CardArticleInterface {
  article: {
    slug: string;
    titulo: string;
    subtitulo: string;
    fecha: string;
    image: {
      file: {
        url: string;
      };
      title: string;
    };
  };
  gtmClass?: string;
}

const CardArticle = (props: CardArticleInterface) => {
  const { article, gtmClass } = props;
  return (
    <div className={`m-card-article`}>
      <div className="m-card-article__img">
        <a href={withPrefix(article.slug)} target="_self" rel={findRel(article.slug)}>
          <img
            src={(article.image && article.image.file.url) || DefaultImage}
            alt={`${formatImageAlt(article.image.title)}`}
            className={`gtm${normalizeTwoWords(gtmClass)}ClicArticulo${normalizeTwoWords(article.titulo)}`}
          />
        </a>
      </div>
      <div className={`m-card-article__cont`}>
        <div className={`m-card-article__cont-left`}>
          <span className={`m-card-article__type`}>Articulo</span>
          <a href={withPrefix(article.slug)} target="_self" rel={findRel(article.slug)}>
            <h3
              className={`m-card-article__title gtm${
                normalizeTwoWords(gtmClass)}ClicArticulo${normalizeTwoWords(article.titulo)
                }`
              }
            >
              {article.titulo}
            </h3>
          </a>
          <div className={`m-card-article__info hide-on-mobile`}>
            {article.subtitulo}
          </div>
        </div>
        <div className={`m-card-article__cont-right`}>
          <span className={`m-card-article__date`}>
            {getFormatDate(+article.fecha)}
          </span>
          <Button
            type={"link"}
            classname={`primary hide-on-mobile gtm${
                normalizeTwoWords(gtmClass)}ClicArticulo${
                normalizeTwoWords(article.titulo)
              }ConoceMás`
            }
            text={"Conoce más"}
            href={withPrefix(article.slug)}
            isDisabled={false}
            target={"_self"}
          />
        </div>
      </div>
      <div className={`m-card-article__icon icon-chevron-right1 show-on-mobile`}></div>
    </div>
  );
};

export default CardArticle;
